export const ETHIOPIAN_REGIONAL_CAPITALS = [
  "Addis Ababa",
  "Adama",
  "Bahir Dar",
  "Hawassa",
  "Mekelle",
  "Jigjiga",
  "Semera",
  "Assosa",
  "Gambella",
  "Harar",
  "Dire Dawa",
];
